import { NgModule } from '@angular/core';
import { HeadingComponent } from './heading.component';
import { HEADING_SIZES, HEADING_TYPES } from './heading.enum';
import { CommonModule } from '@angular/common';

const COMPONENTS = [HeadingComponent];

@NgModule({
	exports: COMPONENTS,
	imports: [CommonModule],
	declarations: COMPONENTS
})
class EdAssistUIHeadingModule {}

export {
	EdAssistUIHeadingModule,
	HeadingComponent,
	HEADING_SIZES,
	HEADING_TYPES
};
